import { create } from "../../../../../common/utils/zustand_state_manager";

type State = {
    idChecklistEntrega?: number;
    descricao?: string;
};

type Action = {
    setIdChecklistEntrega: (idChecklistEntrega: number) => void,
    setDescricao: (descricao: string | undefined) => void,
    clearFilters: () => void
};

export const useChecklistEntregaAmbienteListaFilters = create<State & Action>((set) => ({
    descricao: undefined,
    idChecklistEntrega: undefined,
    setIdChecklistEntrega: (idChecklistEntrega) => set({ idChecklistEntrega }),
    setDescricao: (descricao) => set({ descricao }),
    clearFilters: () => set({
        descricao: undefined,
        idChecklistEntrega: undefined,
    }),
}));

export const initialChecklistEntregaAmbienteFiltersValues: State = {
    descricao: undefined,
    idChecklistEntrega: undefined,
}